import { Link } from "react-router-dom";

const AboutContent = () => {
  return (
    <div>
      <h2 className="text-4xl font-serif mb-6">About Evolutions Medspa</h2>
      <p className="text-lg text-gray-600 mb-6">
        At Evolutions Medspa, we believe in empowering individuals to embrace their unique beauty and enhance their natural features. Our state-of-the-art facility combines advanced aesthetic treatments with personalized care to help you achieve your desired look and feel your absolute best.
      </p>
      <div className="bg-secondary/5 p-6 rounded-lg mb-8">
        <h3 className="text-xl font-semibold mb-4">Dr. William Allen Gray, MD, DMD, MBA, FACS</h3>
        <p className="text-gray-600 mb-4">
          With over 18 years of experience in surgery and reconstruction of the face, Dr. Gray leads our practice with expertise and dedication to achieving natural-looking results. His extensive training and commitment to staying current with the latest advancements ensure our patients receive the highest standard of care.
        </p>
        <ul className="space-y-2 text-gray-600">
          <li>• American Society of Hair Restoration Surgery</li>
          <li>• American Academy of Facial Plastic Surgery</li>
          <li>• MD - Oregon Health & Science University School of Medicine</li>
          <li>• DMD - University of Pennsylvania School of Dental Medicine</li>
          <li>• MBA - Northwestern University Kellogg School of Management</li>
        </ul>
      </div>
      <div className="bg-secondary/5 p-6 rounded-lg mb-8">
        <Link to="/about#hayley" className="group">
          <div className="flex items-center gap-6 mb-4">
            <img
              src="/lovable-uploads/ddda7171-f98c-4340-a038-c5d9952b0df5.png"
              alt="Cosmetic Nurse Hayley"
              className="w-32 h-32 rounded-full object-cover transition-transform group-hover:scale-105"
            />
            <div>
              <h3 className="text-xl font-semibold">Cosmetic Nurse Hayley</h3>
              <p className="text-gray-600">Advanced Aesthetic Practitioner</p>
            </div>
          </div>
        </Link>
        <p className="text-gray-600 mb-4">
          Nurse Hayley is our highly skilled aesthetic nurse practitioner, bringing her expertise and passion for aesthetic medicine to Evolutions Medspa. With advanced training in facial aesthetics and injectable treatments, she combines technical precision with an artistic eye to deliver beautiful, natural-looking results.
        </p>
        <p className="text-gray-600">
          Her gentle approach and commitment to patient education ensure that each client feels comfortable and informed throughout their aesthetic journey. Specializing in facial rejuvenation and enhancement procedures, Nurse Hayley takes pride in helping clients achieve their aesthetic goals while maintaining their unique features.
        </p>
      </div>
      <Link
        to="/contact"
        className="inline-block bg-primary text-white px-8 py-3 rounded-full text-lg hover:bg-primary/90 transition-colors mt-8"
      >
        Schedule a Consultation
      </Link>
    </div>
  );
};

export default AboutContent;